// ============ plugin import ============ //
import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
// ========== module import ============= //

// ============ component import =========== //
import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';

const OthersDataTable = (props) => {
    const {
        index,
        example,
        response,
        action_name,
        folow_up,
        final_response,
        initial_response,
        fail_response,
        information_item
    } = props;

    const othersDeleteOnClick = async (index) => {
        const othersDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (othersDeleteSwal.isConfirmed) {
            props.othersDeleteOnClick(index)
        }
    }

    const othersSetupListDragStart = (e) => {
        e.dataTransfer.setData('text/plain', index);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
        props.onDragDrop(draggedIndex, index);
    };

    return (
        <>
            <tr
                draggable
                onDragStart={othersSetupListDragStart}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                style={{
                    cursor: "move",
                }}
                
            >
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {information_item}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {example}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {response.label}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {action_name}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    { folow_up !== null && folow_up.label}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {final_response}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {initial_response}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {fail_response}
                </td>
                <td className='d-flex float-end'>
                    <div 
                        className='cursor-pointer me-3' 
                        onClick={(e) => { e.preventDefault(); props.othersUpdateOnClick(index);}}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Edit"
                    >
                        <FontAwesomeIcon icon={faPen} className='text-primary fs-3' />
                    </div>
                    <div 
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); othersDeleteOnClick(index)}}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
       
    )
}
const OthersSetupList = (props) => {
    const [othersForm, setOthersForm] = useState([]);
    useEffect(() => {
        if (props.othersForm) {
            setOthersForm(props.othersForm);
        }
    }, [props.othersForm]);
    const othersSetupDropHandler = (draggedIndex, targetIndex) => {
        const updatedList = [...othersForm];
        const [draggedItem] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(targetIndex, 0, draggedItem);
        updatedList.forEach((item, newIndex) => {
            item.index = newIndex;
        });
        setOthersForm(updatedList);
        props.othersSetupListOnDrop(updatedList)
    };
    let othersFormData = '';
    if(othersForm.length > 0){
        othersFormData = othersForm.map((othersData, i) => 
            <OthersDataTable
                key={uuidv4()}
                index = {i}
                information_item= {othersData.information_item}
                example = {othersData.example}
                response = {othersData.select_response}
                action_name = {othersData.action_name}
                folow_up = {othersData.folow_up_details}
                final_response = {othersData.final_response}
                initial_response = {othersData.initial_response}
                fail_response = {othersData.fail_response}
                othersUpdateOnClick = {props.othersUpdateOnClick}
                othersDeleteOnClick = {props.othersDeleteOnClick}
                onDragDrop={othersSetupDropHandler}
            />
        )
    }
    return (
        <>
            {
                othersForm.length > 0 && (
                    <div className='row'>
                        <div className="separator border-gray-300 my-6"></div>
                        <div className='col-md-12'>
                            <div className="table-responsive">
                                <table className="table table-row-dashed align-middle gs-0 gy-4">
                                    <thead>
                                        <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                            <th className="">Information Item</th>
                                            <th className="">Example</th>
                                            <th className="">Response Type</th>
                                            <th className=""> Action </th>
                                            <th className=""> Follow Up </th>
                                            <th className=""> Final Response </th>
                                            <th className=""> Initial Response </th>
                                            <th className=""> Fail Response </th>
                                            <th className=""></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {othersFormData}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )
            }
            
        </>
    )
}
export default OthersSetupList